export const typography = {
  heading: 'prose-headings:text-primary-dark',
  h1: 'prose-h1:text-4xl prose-h1:font-primary',
  h2: 'prose-h2:text-2xl prose-h2:mt-6 prose-h2:mb-4',
  h3: 'prose-h3:text-xl',
  h4: 'prose-h4:text-md',
  h5: 'prose-h5:text-md',
  h6: 'prose-h6:text-md',
  p: 'prose-p:text-sm md:prose-p:text-md prose-h1:text-primary-dark',
  ol: 'prose-ol:mt-0 marker:text-primary-dark',
  ul: 'prose-ul:mt-0 marker:text-primary-dark',
  li: 'prose-li:text-sm md:prose-li:text-md prose-h1:text-primary-dark',
  td: 'prose-td:text-sm md:prose-dt:text-md prose-h1:text-primary-dark',
};
